import { InfoModalType } from '@nx-ng/types';

export interface RadioGroupItemProps<T> {
  titleKey: string;
  subTitleKey?: string;
  value: T;
  isInvalid?: boolean;
  action?: {
    actionLabelKey?: string;
    modalType?: InfoModalType;
    actionStyle?: 'parentheses' | 'info';
  };
}
